<template>
  <div style="width:100%;float:left;">
    <div style="width:100%;float:left;" v-if="!loading">
      {{selectedItem.sold_to_name}} - {{selectedItem.sold_to_number}}
      <hr style="width:80%;margin-left:10%;height:2px;background-color:#e0e0e0;" />
      <CButton
        v-if="data && data.length"
        color="primary"
        class="mb-2" 
        :href="csvCode"
        :download="configureDownload()"
        target="_blank"
      >
        Download current items (.csv)
      </CButton>
      <CDataTable
        v-if="data && fields"
        :items="data"
        column-filter
        hover
        sorter
        :fields="fields"
      >
        <template #units="{item}">
          <td>
            {{item.units && !isNaN(parseInt(item.units)) ? parseInt(item.units).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}}
          </td>
        </template>
        <template #price="{item}">
          <td>
            {{item.price && !isNaN(parseInt(item.price)) ? parseInt(item.price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}}
          </td>
        </template>
      </CDataTable>
    </div>
    <small-loader v-else></small-loader>
  </div>
</template>
<script>
var methods = {}

methods.configureDownload = function () {
  var area = this.data[0].area + '_open_orders.csv'
  // // area + '_sales_dashboard.csv'
  // var area = 'Testing.csv'
  return area
}

methods.getOpenOrders = function () {
  const postData = {
    item: this.selectedItem
  }
  axios.post(this.$apiAdress + '/api/getOpenOrders?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    this.data = response.data
    this.loading = false
  })
}

export default {
  // ===Component name
  name: "OpenOrders",
  // ===Props passed to component
  props: ['selectedItem'],
  // ===Components used by this component
  components: {

  },
  // ====component Data properties
  data(){
      return{
        loading: true,
        data: null,
        fields: ['order_number', 'po_number', 'rep_name', 'product_class', 'program', 'csr', 'units', 'price', 'order_status', 'release_status', 'enter_date', 'ship_date', 'event_date']
      }
  },
  // ===Code to be executed when Component is mounted
  mounted() {
    this.getOpenOrders()
  },
  // ===Computed properties for the component
  computed: {
    csvContent () {
      if (this.data) {
        var fields = ['sold_to_number', 'sold_to_name', 'rep_name', 'order_number', 'po_number', 'product_class', 'program', 'csr', 'units', 'price', 'order_status', 'release_status', 'enter_date', 'ship_date', 'event_date']
        var arr = []
        this.data.forEach(val => {
          var obj = {}
          fields.forEach(field => {
            obj[field] = val[field] !== undefined && val[field] !== null ? val[field] : ''
          })
          arr.push(obj)
        })
        return arr.map(item => Object.values(item).join(',')).join('\n')
      } else {
        return ''
      }
    },
    csvCode () {
      if (this.csvContent) {
        var fields = ['sold_to_number', 'sold_to_name', 'rep_name', 'order_number', 'po_number', 'product_class', 'program', 'csr', 'units', 'price', 'order_status', 'release_status', 'enter_date', 'ship_date', 'event_date']
        var str = fields.join(',') + '%0A'
        return 'data:text/csv;charset=utf-8,' + str + encodeURIComponent(this.csvContent)
      } else {
        return ''
      }
    }
  },
  // ===Component methods
  methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
